module.exports = __webpack_public_path__ + "images/3-facca2ba892f0e3d0510300a32a53c73.jpg";